import sortby from "lodash.sortby";

export default function getSortedLibraryNames(practiceAreas) {
	return sortby(practiceAreas, pa => !pa.active).map(pa => pa.name);
}
